export default __webpack_public_path__ + "static/media/story5.334d9d90.jpg";